<template>
  <v-container fluid v-if="tags && tags.length > 0">
    <p class="label">{{ $t("dash.dictionary.tags.add") }}</p>
    <div class="subcontainer">
      <div class="taglist">
        <a
          class="tag-item"
          v-for="tag in tags"
          :key="tag.id"
          :data-value="JSON.stringify(tag)"
          @click="selectionChanged"
          >{{ tag.name }}</a
        >
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "TagSelector",
  props: {
    tags: { required: true }
  },
  methods: {
    selectionChanged: function(e) {
      this.$emit("selection-changed", e);
    }
  }
};
</script>

<style scoped>
.container {
  width: 90%;
  margin: 16px auto;
  padding-left: 16px;
  padding-right: 16px;
  border-left: 1px solid rgb(49, 185, 190);
}

.subcontainer {
  max-height: 200px;
  overflow-y: auto;
  text-align: left;
}

.label {
  color: #00a9b3;
  margin-bottom: 8px;
  text-align: left;
}

.taglist {
  width: 100%;
  border: 0;
}

.taglist a {
  height: 24px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: OpenSans, sans-serif;
}

.taglist a:hover,
.taglist a:focus {
  background-color: #00a9b3;
  color: #fff;
}
</style>
